<template>
    <div class="page">
      <div class="head-title">
        <div class="left">
          <ul class="breadcrumb">
            <li>
              <router-link to="/accounting/home" class="active">{{
                $t("accounting")
              }}</router-link>
            </li>
            <li>-</li>
            <li>
              <router-link to="/accounting/JournalEntry" class="active">{{
                $t("JL")
              }}</router-link>
            </li>
            <li>-</li>
            <li>
              <a class="active"> {{ `MJ-${alldata2.jid}` }} </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="main">
        <div class="head">
          <div class="head1">
            <!-- <h3>{{ $t("JL") }} ({{ `MJ-${alldata2.jid}` }})</h3> -->
          </div>
          <div class="head2">
            <button @click="pdf" v-if="alldata2.review == 'confirmed'"><i class="bi bi-filetype-pdf"></i> {{ $t("PDF")
            }}</button>
            <button @click="cancel" v-if="alldata2.review == 'confirmed' && hasPermission('property_delete')"
              style="background-color: red">
              {{ $t("delete") }}
            </button>
            <button @click="Edite" v-if="alldata2.review == 'waiting'">
              {{ $t("Edite") }}
            </button>
            <button @click="submit" v-if="alldata2.review == 'waiting'">
              {{ $t("confirm") }}
            </button>
            <button>
              <router-link style="color: white" to="/accounting/JournalEntry" class="active">{{ $t("back") }}
              </router-link>
            </button>
          </div>
        </div>
        <div class="body" id="main">
          <div style="direction: rtl">
            <div class="journal-header">
              <h4>{{ $t("JL") }} ({{ `MJ-${alldata2.jid}` }})</h4>
              <p><strong>{{ $t("type") }}:</strong> {{ alldata2.type }}</p>
              <p><strong>{{ $t("date") }}:</strong> {{ alldata2.date }}</p>
            </div>
            <div class="body1" style="display: flex;">

              <div class="group">
                <label for="basic-url" class="form-label">{{ $t("ccenter") }} {{ $t("parent") }} : {{ alldata2.ccenter }}
                </label>
              </div>
            </div>
            <hr />
            <h6>{{ $t("details") }} {{ $t("JL") }}</h6>

            <table class="table" v-if="alldata2.review == 'waiting'">
              <thead>
                <tr>
                  <th></th>
                  <th scope="col">{{ $t("dpt") }}</th>
                  <th scope="col">{{ $t("crd") }}</th>
                  <th scope="col">{{ $t("Account") }}</th>
                  <td scope="col">{{ $t("ccenter") }}</td>
                  <td scope="col">{{ $t("details") }}</td>
                  <td scope="col">{{ $t("Cancel") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, id) of details" :key="value">
                  <td>{{ id + 1 }}</td>
                  <td scope="row" style="width: 10%">
                    <input class="form-control form-control-sm" type="number" @change="cal" v-model="value.dpt" />
                  </td>
                  <td scope="row" style="width: 10%">
                    <input class="form-control form-control-sm" type="number" @change="cal" v-model="value.crd" />
                  </td>
                  <td scope="row" style="width: 20%">
                    <v-select :options="data1" label="namear" v-model="value.act">
                      <template #option="option">
                        <span>{{ option.namear }}</span>
                      </template>
                    </v-select>
                    <button @click="showAccountModal(id)" class="btn-add-account">
                      {{ $t("add") }} {{ $t("Account") }}
                    </button>
                  </td>
                  <td>
                    <select v-model="value.costcenter">
                      <option v-for="x in costcenter" :key="x" :value="x">
                        {{ x.namear }}
                      </option>
                    </select>
                  </td>
                  <td scope="row" style="width: 30%"><input type="text" v-model="value.details" style="width: 100%;"></td>
                  <td>
                    <a href="#" @click.prevent="del(value)"><i class="bi bi-x-circle-fill"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
            <button @click="add" style="padding: 0.25%" v-if="alldata2.review == 'waiting'">
              {{ $t("add") }} <i class="bi bi-plus"></i>
            </button>
            <table class="table" v-if="alldata2.review == 'confirmed'">
              <thead>
                <tr>
                  <th scope="col">{{ $t("dpt") }}</th>
                  <th scope="col">{{ $t("crd") }}</th>
                  <th scope="col">{{ $t("Account") }}</th>
                  <td scope="col">{{ $t("delegate") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value of trans" :key="value">
                  <td>{{ value.dpt }}</td>
                  <td>{{ value.crd }}</td>
                  <td v-if="css.lang == 'ar'">
                    {{ value.namear }}
                  </td>
                  <td v-if="css.lang == 'en'">
                    {{ value.nameen }}
                  </td>
                  <td>{{ value.delegate }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td>
                    {{ totaldpt }}
                  </td>
                  <td>
                    {{ totalcrd }}
                  </td>
                </tr>
              </tfoot>
            </table>

            <hr />
            <div class="body1" style="display: flex">
              <div class="group">
                <label for="basic-url" class="form-label">{{ $t("total") }} {{ $t("dpt") }} : {{ totaldpt }}
                </label>
                <br />
                <label for="basic-url" class="form-label">{{ $t("total") }} {{ $t("crd") }} : {{ totalcrd }}
                </label>
              </div>
              <div class="group">
                <label for="basic-url" class="form-label">{{
                  $t("description")
                }}
                  <span class="error-feedback" v-if="v$.alldata2.description.$error">{{
                    "*"
                  }}</span>
                </label>
                <div class="mb-3 input-group">
                  <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                    v-model="alldata2.description"></textarea>
                </div>
              </div>
            </div>
            <br />
            <div class="mb-2 row">
              <label class="col-sm-2 col-form-label-sm">
                <i class="bi bi-pin-angle-fill"></i>
                {{ $t("attachments") }}
              </label>
              <div class="breadcrumb">
                <ul v-for="value of fileurl" :key="value">
                  <li>
                    <a :href="this.url + value.name" target="_blank" :download="value.name"><i class="bi bi-download"></i>
                      {{ value.name }}</a>
                  </li>
                </ul>
              </div>
            </div>
            <br />
            <div class="user">
              <i class="bi bi-eye-fill"></i> {{ $t("created") }}
              {{ $t("by") }} : {{ alldata2.username }}
              <div class="udate">
                {{ $t("date") }} : {{ alldata2.date }} - {{ $t("time") }} :
                {{ alldata2.time }}
              </div>
            </div>
            <div class="user" v-if="alldata2.review == 'confirmed'">
              <i class="bi bi-eye-fill"></i> {{ $t("confirmed") }}
              {{ $t("by") }} : {{ alldata2.reviewusername }}
              <div class="udate">
                {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
                {{ alldata2.reviewtime }}
              </div>
            </div>
            <div class="user" v-if="alldata2.review == 'cancel'">
              <i class="bi bi-eye-fill"></i> {{ $t("cancel") }}
              {{ $t("by") }} : {{ alldata2.reviewusername }}
              <div class="udate">
                {{ $t("date") }} : {{ alldata2.reviewdate }} - {{ $t("time") }} :
                {{ alldata2.reviewtime }}
              </div>
            </div>
          </div>
        </div>

        <!-- Modal for Adding New Account -->
        <div class="modal" v-if="showModal">
          <div class="modal-content">
            <div class="modal-header">
              <h4>{{ $t("add") }} {{ $t("Account") }}</h4>
              <button @click="closeModal" class="close">×</button>
            </div>
            <div class="modal-body">
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("Account") }} {{ $t("main") }}</label>
                <div class="col-sm-4">
                  <v-select :options="data1" label="namear" v-model="newAccount.filter">
                    <template #option="option">
                      <span>{{ option.namear }}</span>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="mb-2 row" v-if="newAccount.typeaccountselect">
                <label class="col-sm-2 col-form-label-sm">{{ $t("nature") }} {{ $t("Account") }}</label>
                <div class="col-sm-4">
                  <select class="form-select" v-model="newAccount.typeact">
                    <option value="debit">{{ $t("debit") }}</option>
                    <option value="credit">{{ $t("credit") }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-2 row" v-if="!newAccount.typeaccountselect">
                <label class="col-sm-2 col-form-label-sm">{{ $t("nature") }} {{ $t("Account") }}</label>
                <div class="col-sm-4">
                  <select class="form-select" v-model="newAccount.typeact" disabled>
                    <option value="debit">{{ $t("debit") }}</option>
                    <option value="credit">{{ $t("credit") }}</option>
                  </select>
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("accepte") }} {{ $t("transaction") }}</label>
                <div class="col-sm-4">
                  <input class="form-check-input" type="checkbox" v-model="newAccount.sup" />
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("name") }} {{ $t("ar") }}</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.namear" ref="namearInput" />
                  <span class="error-feedback" v-if="vAccount$.namear.$error">{{ $t("required") }}</span>
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("name") }} {{ $t("en") }}</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.nameen" />
                  <span class="error-feedback" v-if="vAccount$.nameen.$error">{{ $t("required") }}</span>
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("code") }} {{ $t("Account") }}</label>
                <div class="col-sm-4">
                  <input type="text" class="form-control form-control-sm" v-model="newAccount.accountcode" />
                  <span class="error-feedback" v-if="vAccount$.accountcode.$error">{{ $t("required") }}</span>
                </div>
              </div>
              <div class="mb-2 row">
                <label class="col-sm-2 col-form-label-sm">{{ $t("description") }}</label>
                <div class="col-sm-4">
                  <textarea class="form-control" rows="3" v-model="newAccount.description"></textarea>
                  <span class="error-feedback" v-if="vAccount$.description.$error">{{ $t("required") }}</span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button @click="saveAccount" class="btn btn-primary" :disabled="isSaving">
                {{ isSaving ? $t("saving") : $t("save") }}
              </button>
              <button @click="closeModal" class="btn btn-secondary" :disabled="isSaving">{{ $t("cancel") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from "axios";
  import store from "@/store";
  import Swal from "sweetalert2";
  import { mapActions } from "vuex";
  import vSelect from "vue-select";
  import html2pdf from "html2pdf.js";
  import useValidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import { reactive } from "vue";

  export default {
    components: {
      vSelect,
    },
    props: ["css"],
    setup() {
      const newAccount = reactive({
        filter: "",
        itemnum: "",
        namear: "",
        nameen: "",
        accountcode: "1",
        description: "",
        typeaccount: "",
        typeact: "",
        sup: false,
        parent: "",
        level: "",
        typeaccountselect: false,
      });

      const accountRules = {
        namear: { required },
        nameen: { required },
        accountcode: { required },
        description: { required },
      };

      const vAccount$ = useValidate(accountRules, newAccount);

      const state = reactive({
        alldata2: {
          type: "",
          date: "",
          description: "",
        },
      });

      const rules = {
        alldata2: {
          type: { required },
          date: { required },
          description: { required },
        },
      };

      const v$ = useValidate(rules, state);

      return { newAccount, vAccount$, state, v$ };
    },
    async mounted() {
      const result = await axios.get("/data/getaccounttrue");
      const result2 = await axios.get("/data/getcostcenter");
      const result4 = await axios.get("/data/allcustomer");
      const result6 = await axios.get("/data/JournalEntryID");
      if (result.status == 200) {
        this.data1 = result.data.data;
        this.data2 = result.data.data;
        this.branches = result2.data.data.map(item => ({
          ...item,
          actnum: String(item.actnum),
        }));
        this.allprojects = result4.data.data;
        this.costcenter = this.branches.filter((x) => x.sup == "true");
        this.id = Number(result6.data.data[0].count) + Number(1);
      }
      const data2 = await axios.get(
        `/data/JournalEntryReview/${this.$route.params.id}`
      );
      if (data2.status == 200) {
        const data = data2.data.data[0];
        this.alldata2 = data;
        this.state.alldata2 = {
          type: data.type,
          date: data.date,
          description: data.description,
        };
        this.trans = data2.data.data2;
        this.details = JSON.parse(this.alldata2.details);
        this.fileurl = JSON.parse(this.alldata2.fileurl);
        this.url = store.state.imgurl + `/journalentry/`;
        for (let x = 0; x < data.length; x++) {
          const element = data[x];
          data[x].costcenter = JSON.parse(element.costcenter);
        }
      }

      if (this.alldata2.review == "waiting") {
        this.totaldpt = Number(
          this.details.reduce((acc, array) => acc + Number(array.dpt), 0)
        ).toFixed(2);
        this.totalcrd = Number(
          this.details.reduce((acc, array) => acc + Number(array.crd), 0)
        ).toFixed(2);
      }
      if (this.alldata2.review == "confirmed") {
        this.totaldpt = Number(
          this.trans.reduce((acc, array) => acc + Number(array.dpt), 0)
        ).toFixed(2);
        this.totalcrd = Number(
          this.trans.reduce((acc, array) => acc + Number(array.crd), 0)
        ).toFixed(2);
      }
    },
    data() {
      return {
        alldata2: "",
        details: [],
        fileurl: [],
        url: "",
        totaldpt: 0,
        totalcrd: 0,
        costcenter: [],
        showModal: false,
        isSaving: false,
        selectedRowIndex: null,
        err: false,
      };
    },
    methods: {
      add() {
        this.details.push({
          dpt: 0,
          crd: 0,
          act: "",
          actnum: "",
          namear: "",
          nameen: "",
          details: "",
          totaldpt: 0,
          totalcrd: 0,
          costcenter: { actnum: "", namear: "" },
          err: false,
        });
      },
      cal() {
        this.totaldpt = Number(
          this.details.reduce((acc, array) => acc + Number(array.dpt), 0)
        ).toFixed(2);
        this.totalcrd = Number(
          this.details.reduce((acc, array) => acc + Number(array.crd), 0)
        ).toFixed(2);
      },
      async submit() {
        for (let i = 0; i < this.details.length; i++) {
          const element = this.details[i];

          if (!element.act) {
            this.err = true;
            const Toast = Swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "error",
              title: "برجاء مراجعة القيد",
            });
            break;
          } else {
            this.err = false;
          }
        }
        console.log(this.totalcrd );
        console.log(this.totaldpt );

        if (this.totalcrd == this.totaldpt && this.totalcrd != 0 && this.err == false) {
          Swal.fire({
            title: this.$t("confirm") + "-" + this.$t("JL"),
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
          }).then(async (result) => {
            if (result.isConfirmed) {
              const action = await axios.post("/data/confirmjournalentry", {
                id: this.alldata2.jid,
                username: store.state.randp.username,
                trandate: this.alldata2.trandate,
                branch: this.alldata2.branch,
                description: this.alldata2.description,
                details: this.details,
                project: this.alldata2.project,
                task: this.alldata2.task,
              });
              if (action.status == 200) {
                Swal.fire(
                  this.$t("done") + " " + this.$t("confirm"),
                  this.$t("JL")
                );
                this.redirectTo({ val: "JournalEntry" });
              }
            }
          });
        }
      },
      async cancel() {
        Swal.fire({
          title: this.$t("delete") + "-" + this.$t("JL"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: this.$t("delete"),
        }).then(async (result) => {
          if (result.isConfirmed) {
            const action = await axios.post("/data/canceljournalentry", {
              id: this.alldata2.jid,
              username: store.state.randp.username,
            });
            if (action.status == 200) {
              Swal.fire(this.$t("done") + " " + this.$t("cancel"), this.$t("JL"));
              this.redirectTo({ val: "JournalEntry" });
            }
          }
        });
      },
      async Edite() {
        await this.v$.$validate();
        if (!this.v$.$error) {
          Swal.fire({
            title: this.$t("Edite") + "-" + this.$t("JL"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: this.$t("Edite"),
          }).then(async (result) => {
            if (result.isConfirmed) {
              const action = await axios.post("/data/editejournalentry", {
                id: this.alldata2.jid,
                details: JSON.stringify(this.details),
                username: store.state.randp.username,
                type: this.alldata2.type,
                date: this.alldata2.date,
                description: this.alldata2.description,
              });
              if (action.status == 200) {
                Swal.fire(this.$t("done") + " " + this.$t("Edite"), this.$t("JL"));
                this.redirectTo({ val: "JournalEntry" });
              }
            }
          });
        } else {
          const errors = this.v$.$errors
            .map(error => `${error.$propertyPath}: Value is required`)
            .join('\n');
          const Toast = Swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          Toast.fire({
            icon: "error",
            title: "Validation Errors",
            text: errors,
          });
        }
      },
      pdf() {
        html2pdf(document.getElementById("main").innerHTML, {
          margin: 0.2,
          filename: "JournalReport.pdf",
          image: { type: "jpeg", quality: 100 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        });
      },
      del(value) {
        const indexOfObject = this.details.findIndex((object) => {
          return (
            object.namear === value.namear &&
            object.nameen === value.nameen &&
            object.details === value.details
          );
        });
        this.details.splice(indexOfObject, 1);
      },
      hasPermission(permission) {
        return store.state.randp.permissions.includes(permission);
      },
      showAccountModal(rowIndex) {
        this.selectedRowIndex = rowIndex;
        this.showModal = true;
        this.resetNewAccount();
        this.$nextTick(() => {
          this.$refs.namearInput.focus();
        });
      },
      closeModal() {
        this.showModal = false;
        this.selectedRowIndex = null;
        this.resetNewAccount();
      },
      resetNewAccount() {
        Object.assign(this.newAccount, {
          filter: "",
          itemnum: "",
          namear: "",
          nameen: "",
          accountcode: "1",
          description: "",
          typeaccount: "",
          typeact: "",
          sup: false,
          parent: "",
          level: "",
          typeaccountselect: false,
        });
        this.isSaving = false;
        this.vAccount$.$reset();
      },
      async saveAccount() {
        await this.vAccount$.$validate();
        if (!this.vAccount$.$error) {
          this.isSaving = true;
          try {
            const result = await axios.post("/data/accountingmanual", {
              username: store.state.randp.username,
              namear: this.newAccount.namear,
              nameen: this.newAccount.nameen,
              actnum: String(this.newAccount.accountcode),
              parent: this.newAccount.parent,
              description: this.newAccount.description,
              typeaccount: this.newAccount.typeaccount,
              typeact: this.newAccount.typeact,
              sup: this.newAccount.sup,
              level: this.newAccount.level,
            });
            if (result.status == 200) {
              const newAccountData = {
                namear: this.newAccount.namear,
                nameen: this.newAccount.nameen,
                actnum: String(this.newAccount.accountcode),
                parent: this.newAccount.parent,
                description: this.newAccount.description,
                typeaccount: this.newAccount.typeaccount,
                typeact: this.newAccount.typeact,
                sup: this.newAccount.sup,
                level: this.newAccount.level,
              };
              this.data1.push(newAccountData);
              if (this.selectedRowIndex !== null) {
                this.details[this.selectedRowIndex].act = newAccountData;
              }
              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              Toast.fire({
                icon: "success",
                title: "Account Created Successfully",
              });
              this.closeModal();
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Account Creation Failed",
              });
            }
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Account Already Exists or Invalid Data",
            });
          } finally {
            this.isSaving = false;
          }
        }
      },
      ...mapActions(["redirectTo"]),
    },
    watch: {
      "newAccount.filter"() {
        if (this.newAccount.filter) {
          this.newAccount.itemnum = this.newAccount.filter.actnum;
          this.newAccount.level = Number(this.newAccount.filter.level) + 1;
        }
      },
      "newAccount.itemnum"() {
        if (this.newAccount.itemnum == "main") {
          this.newAccount.typeaccountselect = true;
          const mainAccounts = this.data1.filter((x) => String(x.actnum).length == 1);
          const last = mainAccounts[mainAccounts.length - 1];
          const lastnu = last ? last.actnum : "0";
          this.newAccount.accountcode = String(Number(lastnu) + 1);
        } else {
          const filteredAccounts = this.data1.filter((x) =>
            String(x.actnum).startsWith(String(this.newAccount.itemnum).toLowerCase())
          );
          this.newAccount.typeaccountselect = false;
          if (filteredAccounts.length > 0) {
            this.newAccount.typeaccount = filteredAccounts[0].typeaccount;
            this.newAccount.typeact = filteredAccounts[0].typeact;
            this.newAccount.parent = filteredAccounts[0].actnum;
            if (filteredAccounts.length > 1) {
              const last = filteredAccounts.slice(1);
              const lastarr = last[last.length - 1];
              const lastnu = lastarr.actnum;
              this.newAccount.accountcode = String(Number(lastnu) + 1);
            } else {
              const lastnu = filteredAccounts[0].actnum;
              this.newAccount.accountcode = lastnu + "01";
            }
          }
        }
      },
      "alldata2.type"(newVal) {
        this.state.alldata2.type = newVal;
      },
      "alldata2.date"(newVal) {
        this.state.alldata2.date = newVal;
      },
      "alldata2.description"(newVal) {
        this.state.alldata2.description = newVal;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .page {
    padding: 0.5%;
  }

  .main {
    width: 98%;
    margin: 1%;
    padding: 1%;
    border-radius: 5px;
    border: ridge 0.5px;
  }

  .main .body {
    padding: 1%;
  }

  .head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
  }

  .head1 {
    width: 70%;
  }

  .head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .head2 {
    width: 30%;
    text-align: center;
  }

  button {
    margin: 0.5%;
    padding: 2%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
  }

  .group {
    padding: 1%;
    width: 50%;
  }

  .group input {
    width: 80%;
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  select {
    width: 80%;
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
  }

  .table {
    margin-top: 1%;
  }

  table thead tr {
    border-radius: 5px;
    background-color: #eee;
  }

  .btn-add-account {
    margin-top: 0.5%;
    padding: 0.5%;
    font-size: 0.8rem;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 50%;
    max-height: 80%;
    overflow-y: auto;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  .modal-header .close {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }

  .modal-body {
    padding: 20px 0;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid #ddd;
    padding-top: 10px;
  }

  .modal-footer button {
    margin-left: 10px;
    padding: 8px 16px;
    border-radius: 5px;
  }

  .modal-footer .btn-primary:disabled {
    background-color: #a0a0a0;
    cursor: not-allowed;
  }

  .error-feedback {
    color: red;
    margin-left: 5px;
    font-size: 0.8rem;
  }
  </style>
